import React from "react";
import { Field } from "formik";
import { TextField, CheckboxWithLabel } from "formik-material-ui";
import { Grid, makeStyles, SearchSelect, FormControlLabel } from "../../../../";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "no-wrap",
      padding: "20px"
    },
    mr30: {
      "margin-right": "30px"
    },
    flex: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    w30: {
      width: "30%"
    },
    w45: {
      width: "45%"
    },
    w90: {
      width: "90%"
    }
  };
});

var BillingInfoForm = function BillingInfoForm(_ref) {
  var values = _ref.values,
      mode = _ref.mode,
      taxes = _ref.taxes,
      contact = _ref.contact,
      translation = _ref.translation;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.flex
  }, !contact && /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Field, {
      label: translation ? translation.inputs.legal_entity : "Is Legal Entity ?",
      name: "billingInfo.isLegalEntity",
      key: "billingInfo.isLegalEntity",
      "data-cy": "billingInfo.isLegalEntity",
      component: CheckboxWithLabel,
      color: "primary",
      disabled: mode === "view"
    }),
    label: translation ? translation.inputs.legal_entity : "Is Legal Entity ?"
  }), /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.name",
    key: "billingInfo.name",
    className: [classes.mr30, classes.w45].join(" "),
    fullWidth: true,
    label: translation ? translation.inputs.name : "Legal Entity Name/Name",
    placeholder: translation ? translation.inputs.name : "Legal Entity Name/Name",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  }), !values.billingInfo.isLegalEntity && !contact && [/*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.firstSurname",
    key: "billingInfo.firstSurname",
    className: [classes.mr30, classes.w45].join(" "),
    fullWidth: true,
    label: "Primer apellido",
    placeholder: "Primer apellido",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.lastSurname",
    key: "billingInfo.lastSurname",
    className: [classes.mr30, classes.w45].join(" "),
    fullWidth: true,
    label: "Segundo apellido",
    placeholder: "Segundo apellido",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  })], /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.vat_number",
    key: "billingInfo.vat_number",
    className: [classes.mr30, classes.w45].join(" "),
    label: translation ? translation.inputs.vat_number : "Vat number",
    placeholder: translation ? translation.inputs.vat_number : "Vat number",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12
  }, /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.address",
    key: "billingInfo.address",
    className: [classes.mr30, classes.w90].join(" "),
    label: translation ? translation.inputs.address : "Address",
    placeholder: translation ? translation.inputs.address : "Address",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.zipcode",
    key: "billingInfo.zipcode",
    className: [classes.mr30, classes.w30].join(" "),
    label: translation ? translation.inputs.zipcode : "Postal Code",
    placeholder: translation ? translation.inputs.zipcode : "Postal Code",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.town",
    key: "billingInfo.town",
    className: [classes.mr30, classes.w30].join(" "),
    label: translation ? translation.inputs.town : "City",
    placeholder: translation ? translation.inputs.town : "City",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.province",
    key: "billingInfo.province",
    className: [classes.mr30, classes.w30].join(" "),
    label: translation ? translation.inputs.province : "Province",
    placeholder: translation ? translation.inputs.province : "Province",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  })), !contact && /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.tax_rate",
    key: "billingInfo.tax_rate",
    style: {
      width: "50%"
    },
    component: SearchSelect,
    placeholder: "Tax Rate",
    options: taxes,
    variant: "outlined",
    disabled: mode === "view"
  }));
};

export { BillingInfoForm };